<template>
  <div>
    <!--app-nav :loggedIn="loggedIn"></app-nav-->

    <router-view></router-view>
  </div>
</template>

<script>
import moment from "moment";
export default {
  method: {
    frontEndDateFormat(date) {
      //alert(date);
      return moment(date, "YYYY-MM-DD H:i:s").format("DD/MM/YYYY h:i");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },
    scrollToTop() {
      //alert("hii");
      window.scrollTo(0, 0);
    },
    currentDate() {
      //alert("current date " + moment("YYYY-MM-DD H:i:s").format("DD-MM-YYYY"));
      return moment("YYYY-MM-DD H:i:s").format("DD-MM-YYYY");
    },
    encodeString(string) {
      //alert("app vue called");
      return window.btoa(string);
    },
    checkToken() {
      const token = localStorage.getItem("token");
      // alert(token);
      if (token == null) {
        this.$router.push("/signin");
      }
    },
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loginState;
    },
  },
  name: "App",
  components: {
    //appNav: Nav,
  },
  created() {
    const expires = localStorage.getItem("expires");
    const token = localStorage.getItem("token");

    if (expires && token) {
      var expiresMs = new Date(expires);
      var now = new Date();
      now = now.getTime();
      expiresMs = expiresMs.getTime();
      if (now > expiresMs) {
        this.$store.dispatch("logout");
      } else {
        this.$store.dispatch("login", expiresMs - now);
      }
    }
  },
};
</script>

<style>
a {
  text-decoration: none !important;
  color: inherit;
}
#preloader {
  display: none;
}
body {
  background-color: #ffffff;
}
.form-wrapper {
  border-radius: 7px;
}
.form-wrapper label {
  font-weight: bold;
}
.errors li {
  list-style: none;
  width: 100%;
  text-align: center;
}
.errors ul {
  padding-left: 0;
  margin-bottom: 0;
}
.bg-dark {
  background-color: unset !important;
}
@media (max-width: 768px) {
  .form-wrapper .text-right {
    text-align: center !important;
  }

  .form-wrapper .btn-primary {
    display: block;
    margin: 0 auto;
  }
}
</style>
